import React from "react";
import {
  Alert,
  Button,
  Code,
  Group,
  Modal,
  Stack,
  Text,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { notifications } from "@mantine/notifications";
import { FiRepeat } from "react-icons/fi";
import { openapi } from "../../openapi";

type Props = {
  projectNo: number;
  disabled?: boolean;
  onCompleted?: () => void;
};

export const DrofusDiffLatestButton: React.FC<Props> = ({
  projectNo,
  disabled = false,
  onCompleted,
}) => {
  const [opened, { open, close }] = useDisclosure(false);
  const [diffLatest, { isLoading }] =
    openapi.endpoints.postMultiplacerDrofusInterfaceOccurrencesDiffLatest.useMutation();

  const handleRun = async () => {
    try {
      const result = await diffLatest({ body: { projectNo } }).unwrap();
      notifications.show({
        color: "green",
        title: "Diff opprettet",
        message: `${result.changeEventCount} endringer mellom de to siste kjøringene.`,
      });
      close();
      onCompleted?.();
    } catch (error) {
      notifications.show({
        color: "red",
        title: "Kunne ikke opprette diff",
        message: error instanceof Error ? error.message : "Se konsollen eller backend-loggene.",
      });
    }
  };

  return (
    <>
      <Button
        size="xs"
        radius="sm"
        variant="subtle"
        leftSection={<FiRepeat size={14} />}
        disabled={disabled}
        loading={isLoading}
        onClick={open}
      >
        Diff siste
      </Button>

      <Modal opened={opened} onClose={close} title="Diff siste dRofus-kjøringer" size="md" centered>
        <Stack gap="sm">
          <Alert color="blue" variant="light" radius="sm">
            Lager diff mellom de to siste vellykkede forekomstkjøringene for prosjektet.
          </Alert>

          <Stack gap={4}>
            <Text size="sm" fw={600}>
              Body
            </Text>
            <Code block>{JSON.stringify({ projectNo }, null, 2)}</Code>
          </Stack>

          <Group justify="flex-end" gap="xs">
            <Button size="xs" variant="subtle" radius="sm" onClick={close}>
              Avbryt
            </Button>
            <Button size="xs" radius="sm" loading={isLoading} onClick={handleRun}>
              Start diff
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
};
